import { render, staticRenderFns } from "./seguimientoCuentasGeneral.vue?vue&type=template&id=028c18ce"
import script from "./seguimientoCuentasGeneral.vue?vue&type=script&lang=js"
export * from "./seguimientoCuentasGeneral.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports